import { render } from "./DeleteVaccinationDialog.vue?vue&type=template&id=46ff9700"
import script from "./DeleteVaccinationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteVaccinationDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__